<template>
<div class="element-root">
    <div class="mds-heading-level-3">
        <br>
         <span class="screen-align">GBM Data Update
                <mds-alert variation="success" tinted v-if="isSuccess" class="alert-box-msg">
                    File succesfully uploaded 
                </mds-alert>
        </span>
        <mds-section border="secondary" title="" class="mds-section-1" borderPosition="bottom">
        </mds-section>
    </div>
    <span class="body-text-1">
        Upload Indicators File
    </span>
    <br><br>
    <div class="file_upload_container">
      <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
      <div>
        <input type="file" :name="uploadFieldName" :disabled="isSaving" 
        @change="fileChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
        accept="xlsx" class="input-file"/>
        <div v-if="isInitial || isSuccess" class="body-text-2">
          <p><strong>Drag and drop file here</strong> or <strong class="browse-link" @click="importFile()">browse</strong></p>
          <br>
          <p>Accepted files: XLSX</p>
          <p>Max file size: 50 MB</p>
        </div>
        <p v-if="isSaving" class="body-text-2"><strong>Uploading file...</strong></p>
      </div>
      </form> 

      <div v-if="isSuccess" class="body-text-2">
        <strong>
            <h2> Uploaded {{uploadedFiles.length}} file(s)  successfully.</h2>
            <p><a href="javascript:void(0)" @click="reset()">Upload again</a></p>
        </strong>
      </div>

      <!-- <div v-if="isFailed">
        <h2>Upload Failed.</h2>
        <p><a href="javascript:void(0)" @click="reset()">Try Again</a></p>
        <pre>{{uploadError}}</pre>
      </div> -->
    </div>
    <br><br>
    <div class="flex-container-1">
        <mds-section container title="Updates History" bold>
            <mds-table>
                <mds-thead>
                    <!-- <mds-th>File Type</mds-th> -->
                    <mds-th>Document Name</mds-th>
                    <mds-th>Date Uploaded</mds-th>
                    <mds-th>File Size</mds-th>
                    <mds-th></mds-th>
                </mds-thead>
                <mds-tbody>
                    <mds-tr v-for='(row, index) in listOfFilesOnS3' v-bind:key="index">
                        <mds-td>{{row['Key']}}</mds-td>
                        <mds-td>{{row.LastModified}}</mds-td>
                        <mds-td>{{row.Size}} MB</mds-td>
                        <mds-td><mds-button variation="primary" @click="generateDownloadLink(row['Key'])">Download</mds-button></mds-td>
                    </mds-tr>
                </mds-tbody>
            </mds-table>
        </mds-section>
    </div>
</div>
</template>

<script>
import {MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd} from '@mds/data-table';
import MdsSection from '@mds/section';
import MdsButton from '@mds/button/src/button.vue';
import MdsAlert from '@mds/alert';

import { upload } from './file-upload.service';
import {getPresignedURL} from './get-presigned-url.service';
import {generateDownloadLink_s3} from './file-download.service'
import {get_s3_bucket_objects_list} from './s3-bucket.service';

const STATUS_INITIAL = 0, STATUS_SAVING=1, STATUS_SUCCESS =2, STATUS_FAILED=3;

export default {
    name:"FileUpload",
    components: {
        MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd,
        MdsSection,
        MdsButton,
        MdsAlert
    },
    data(){
        return { 
            uploadedFiles: [],
            uploadError: null,
            currentStatus: 0,
            uploadFieldName: 'excel',
            listOfFilesOnS3: []
        }
    },
    computed: {
        isInitial() {
        return this.currentStatus === STATUS_INITIAL;
        },
        isSaving(){
        return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed(){
        return this.currentStatus === STATUS_FAILED;
        }
    },
    methods: {
        importFile(){
            console.log('importFile called...')
            let input = document.createElement('input');
            input.type = 'file';
            input.accept = 'xlsx';
            
            input.onchange = _=> {
                this.fileChange(input.files[0].name, Array.from(input.files))
            }
            input.click();
        },

        async fileChange(fieldName, fileList){
            const xlsxFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            if(fileList[0].type !== xlsxFileType){
                alert('only Excel (.xlsx) files are allowed!')
                this.currentStatus === STATUS_INITIAL
                return
            }

            console.log('getting presignedURL from backend')
            const url = await getPresignedURL(fileList[0].name, fileList[0].type)
            console.log('Presigned URL is: ' + url)
        
            if(!fileList.length) return;

            console.log('uploading file to S3')
            this.save(url, fileList[0], fileList[0].name, fileList[0].type);
        },

        save(url, formData, fileName, fileType){
            this.currentStatus = STATUS_SAVING;

            upload(url, formData, fileName, fileType)
                .then(x => {
                    this.uploadedFiles = [].concat(x);
                    this.currentStatus = STATUS_SUCCESS;
                    console.log('File Uploaded to s3, resp = ' + x)
                    setTimeout(() => {location.reload()}, 22000)
                })
                .catch(err => {
                    this.uploadError = err.response;
                    this.currentStatus = STATUS_FAILED;
                });
        },

        async generateDownloadLink(downloadFileName){
            console.log('File to download = ' + downloadFileName)
            let link = await generateDownloadLink_s3(downloadFileName)
            console.log('download link = ' + link)
            window.open(link, '_blank')
        },

        async listS3BucketObjects(){
            console.log('list fun called')
            ;({Contents: this.listOfFilesOnS3} =  await get_s3_bucket_objects_list())
            for(let i=0; i<this.listOfFilesOnS3.length; i++){
                this.listOfFilesOnS3[i]['Size'] = (this.listOfFilesOnS3[i]['Size']/1048576).toFixed(2)
                this.listOfFilesOnS3[i]['Key']  = this.listOfFilesOnS3[i]['Key'].replace('python-output/', '')
            }
            this.listOfFilesOnS3 = {...this.listOfFilesOnS3} 
        },

        reset() {
            this.currentStatus =STATUS_INITIAL;
            this.uploadedFiles=[];
            this.uploadError=null;
        },
    },
    mounted() {
        this.reset()
        this.listS3BucketObjects()
    }
}
</script>

<style lang="scss" scoped>
@import '@mds/typography';
@import '@mds/constants';
@import '@mds/link';

.alert-box-msg{
    display: flex;
    justify-content: center;
    max-width: 350px;
    max-height: 50px;
}

.screen-align{
    position: relative;
    left: 60px;
}

.file_upload_container {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: 0px;
    background: #f2f2f2;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    cursor: pointer;
    max-width: 700px;
    text-align: center;    
    position: relative;
    left: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

   .file_upload_container:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
}

.browse-link{
    @include mds-link($underline: true);
    color: blue;
}

.mds-heading-level-3 {
    @include mds-level-3-heading($bold: true);
    color: $mds-text-color-primary;
}

.body-text-1{
    @include mds-body-text-m($bold: true);
    position: relative;
    left: 60px;    
}

.body-text-2{
    @include mds-body-text-m()
}

.flex-container-1{
    max-width: 700px;
    position: relative;
    left: 60px;
}

.flex-container-2{
    display: flex;

}
</style>
